/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-06-26 15:09:20
 * @LastEditTime: 2019-10-22 17:18:55
 * @LastEditors: Please set LastEditors
 */
import axios from 'axios';
import qs from 'qs';
axios.defaults.timeout = 500000;
axios.defaults.withCredentials = true;
//http request 拦截器

axios.interceptors.request.use(
    config => {
        config.data = qs.stringify(config.data);
        config.headers = {
                'Content-Type': 'application/x-www-form-urlencoded',
                'accept': 'application/json',
            }
        //  localStorage.setItem('access_tokens', 'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6IjljZWI0MmVmYTRiNmNhMWNhZmM0M2ZkMjJjMDZlNGQxOThjMzFmMjFjYmQzZWVkN2YwOWU1YzkwYmNkMTM0MWUzZjZhOGJkMGVjZjYzZTM2In0.eyJhdWQiOiIxMDA4ODAwMyIsImp0aSI6IjljZWI0MmVmYTRiNmNhMWNhZmM0M2ZkMjJjMDZlNGQxOThjMzFmMjFjYmQzZWVkN2YwOWU1YzkwYmNkMTM0MWUzZjZhOGJkMGVjZjYzZTM2IiwiaWF0IjoxNjE2MDU2MDI2LCJuYmYiOjE2MTYwNTYwMjYsImV4cCI6MTYxNzM1MjAyNiwic3ViIjoiMTM5Iiwic2NvcGVzIjpbIioiXX0.FNW5Nqeg-ofiA00blXSi9VFoKR6Ql1iKUZCrifqeKLLdDKiiNvzZjxSXMY1gc2OuprD-Sxq-aJcEh0a2YMVzmG5dyKaYaCTq1d_LoM43VmtxYyvsvw7HjCw2UGOnABwQycMD7708XirZl2R1OfIuGvf2L26kuOG4LFpB0FF1BSMoe1sueON1YjG6SN1I3Ra7zuTICvNwcCmzux2hcwqdw1stvLpFAIaBvA3C5-v-rjN5yCYEjG4TQmMFZnMb52vIUM6MDEz24atZceaVc2aysLdzudMfIn-DJk8PFFjH6FYOMAnMnHOXx4mZH-N6hA5_duWIJ7E_N0p_0d_xiCbWi5OO84Jwd5GJrhQJruEWVoT0xvJY8cDX9JBnb5KLTvjcYTZCoeMojdZxIBRwmLMA8w54JjEv8Ip2FnnFCiCBAY8LLtiWJdCLwsjU3hINhwi2-HLVbuDDoQSkg-A8x7TrtLciVOV9jMWM-WMr5EfEubHU6ZKKsYxS5kXhxTvMi87R-2oLzRzaEEWJUBBhXrl_wqqLIdBqFrZjk5n341ojzqQSD3z4Qp8wrsQuOltH5S13cRUxN8f5cMnYY6UA3wqH-7SMj6B7HZ0cc1oBd1EfmgYIB5IkosZ5Py7Zm8K3mJ7KzwR6IvxqmfUFcbo6oTEhvOPaaAHazWaRhaLipt7_3RA')
        config.headers.Authorization = 'Bearer' + " " + localStorage.getItem('access_tokens')
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);
//http response 拦截器
axios.interceptors.response.use(
    response => {
        if (response.data.code == 100) {
            location.href = location.href.split('#/')[0] + '#/login'; //跳回登陆页面
        }
        return response;
    },
    error => {
        return Promise.reject(error.response.data)
    }
)

//定义全局的api
let api;

if(process.env.VUE_APP_type == 'development'){
    api = {
        logistics:'http://logistics.c.smartcode.vip/admin/v2',
        logistics_2:'http://pps.c.smartcode.vip/index.php/',
    }
}else if(process.env.VUE_APP_type == 'production'){
    api = {
        logistics:'https://logistics.smartcode.vip/admin/v2',
        logistics_2:'https://pps.smartcode.vip/index.php/',
    }
}else if(process.env.VUE_APP_type == 'person'){
    api = {
        logistics:'http://logistics.tx315.vip/admin/v2',
        logistics_2:'http://pps.tx315.vip/index.php/',
    }
}else  if(process.env.VUE_APP_type=='zd'){
    api = {
        logistics:'http://logistics.cn2de.com/admin/v2',
        logistics_2:'http://pps.cn2de.com/index.php/',
    }
 }else  if(process.env.VUE_APP_type=='hd'){
    api = {
        logistics:'https://qyhb-logistics.haid.com.cn/admin/v2',
        logistics_2:'https://qyhb-pps.haid.com.cn/index.php/',
    }
 }else  if(process.env.VUE_APP_type=='ym'){
    api = {
        logistics:'https://logistics.ymsaas.com/admin/v2',
        logistics_2:'https://pps.ymsaas.com/index.php/',
    }
 }else  if(process.env.VUE_APP_type=='kjifen'){
    api = {
        logistics:'https://logistics.keleshuma.com/admin/v2',
        logistics_2:'https://pps.keleshuma.com/index.php/',
    }
 }else  if(process.env.VUE_APP_type=='ncbu'){
    api = {
        logistics:'https://logistics.ncbu.cn/admin/v2',
        logistics_2:'https://pps.ncbu.cn/index.php/',
    }
 }else  if(process.env.VUE_APP_type=='dy'){
    api = {
        logistics:'https://logistics.dayanga.net/admin/v2',
        logistics_2:'https://pps.dayanga.net/index.php/',
    }
 }else  if(process.env.VUE_APP_type=='qs'){
    api = {
        logistics:'https://logistics.qsfw.net/admin/v2',
        logistics_2:'https://pps.qsfw.net/index.php/',
    }
 }else  if(process.env.VUE_APP_type=='xc'){
    api = {
        logistics:'https://logistics.cnxcyx.com/admin/v2',
        logistics_2:'https://pps.cnxcyx.com/index.php/',
    }
 }else  if(process.env.VUE_APP_type=='kmd'){
    api = {
        logistics:'https://logistics.s106.xcx008.com/admin/v2',
        logistics_2:'https://pps.s106.xcx008.com/index.php/',
    }
 }else  if(process.env.VUE_APP_type=='wj'){
    api = {
        logistics:'https://logistics.wjkj907.cn/admin/v2',
        logistics_2:'https://pps.wjkj907.cn/index.php/',
    }
 }else  if(process.env.VUE_APP_type=='ry'){
    api = {
        logistics:'https://logistics.fwmcx.com/admin/v2',
        logistics_2:'https://pps.fwmcx.com/index.php/',
    }
 }else  if(process.env.VUE_APP_type=='bcx'){
    api = {
        logistics:'https://logistics.baochengxin.com/admin/v2',
        logistics_2:'https://pps.baochengxin.com/index.php/',
    }
 }else  if(process.env.VUE_APP_type=='tkkj'){
    api = {
        logistics:'https://logistics.tksmys.com/admin/v2',
        logistics_2:'https://pps.tksmys.com/index.php/',
    }
 }else  if(process.env.VUE_APP_type=='zhsw'){
    api = {
        logistics:'https://logistics.ccsmartid.com/admin/v2',
        logistics_2:'https://pps.ccsmartid.com/index.php/',
    }
 }
 
/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */
export function fetch(module, url, params = {}) {
    let baseUrl = '';
    if (module == "logistics") {
        baseUrl = api.logistics + url;
    } else if (module == "logistics_2") {
        baseUrl = api.logistics_2 + url;
    } else if (module == "linglong") {
        baseUrl = api.linglong + url;
    }
    return new Promise((resolve, reject) => {
        axios.get(baseUrl, {
                params: params
            })
            .then(response => {
                resolve(response.data);
            })
            .catch(err => {
                reject(err)
            })
    })
}


/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function post(module, url, data = {}) {
    if (module == "logistics") {
        url = api.logistics + url;
    } else if (module == "logistics_2") {
        url = api.logistics_2 + url;
    } else if (module == "linglong") {
        url = api.linglong + url;
    }
    return new Promise((resolve, reject) => {
        axios.post(url, data)
            .then(response => {
                resolve(response.data);
            }, err => {
                reject(err)
            })
    })
}

/**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function patch(module, url, data = {}) {
    if (module == "logistics") {
        url = api.logistics + url;
    } else if (module == "logistics_2") {
        url = api.logistics_2 + url;
    } else if (module == "linglong") {
        url = api.linglong + url;
    }
    return new Promise((resolve, reject) => {
        axios.patch(url, data)
            .then(response => {
                resolve(response.data);
            }, err => {
                reject(err)
            })
    })
}

/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function put(module, url, data = {}) {
    if (module == "logistics") {
        url = api.logistics + url;
    } else if (module == "logistics_2") {
        url = api.logistics_2 + url;
    } else if (module == "linglong") {
        url = api.linglong + url;
    }
    return new Promise((resolve, reject) => {
        axios.put(url, data)
            .then(response => {
                resolve(response.data);
            }, err => {
                reject(err)
            })
    })
}
/**
 * 封装delete请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function del(module, url, data = {}) {
    if (module == "logistics") {
        url = api.logistics + url;
    } else if (module == "logistics_2") {
        url = api.logistics_2 + url;
    } else if (module == "linglong") {
        url = api.linglong + url;
    }
    return new Promise((resolve, reject) => {
        axios.delete(url, data)
            .then(response => {
                resolve(response.data);
            }, err => {
                reject(err)
            })
    })
}